var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleScatterHaikei(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "visual",
    viewBox: "0 0 900 600",
    width: 900,
    height: 600,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 900,
    height: 600,
    fill: "#009473"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 86,
    cx: 61,
    cy: 389
  }), /*#__PURE__*/React.createElement("circle", {
    r: 54,
    cx: 314,
    cy: 308
  }), /*#__PURE__*/React.createElement("circle", {
    r: 79,
    cx: 609,
    cy: 385
  }), /*#__PURE__*/React.createElement("circle", {
    r: 75,
    cx: 893,
    cy: 147
  }), /*#__PURE__*/React.createElement("circle", {
    r: 59,
    cx: 258,
    cy: 39
  }), /*#__PURE__*/React.createElement("circle", {
    r: 69,
    cx: 370,
    cy: 585
  }), /*#__PURE__*/React.createElement("circle", {
    r: 59,
    cx: 711,
    cy: 557
  }), /*#__PURE__*/React.createElement("circle", {
    r: 63,
    cx: 805,
    cy: 336
  }), /*#__PURE__*/React.createElement("circle", {
    r: 56,
    cx: 139,
    cy: 191
  }), /*#__PURE__*/React.createElement("circle", {
    r: 65,
    cx: 496,
    cy: 226
  }), /*#__PURE__*/React.createElement("circle", {
    r: 80,
    cx: 135,
    cy: 579
  }), /*#__PURE__*/React.createElement("circle", {
    r: 62,
    cx: 681,
    cy: 96
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleScatterHaikei);
export default __webpack_public_path__ + "static/media/circle-scatter-haikei.a67496a90245e67cf76ae8217890ceb9.svg";
export { ForwardRef as ReactComponent };